class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.currentIndex = 0;
    this.intervalId = null;

    this.touchStartX = 0;
    this.touchEndX = 0;

    this.track = this.querySelector(
      "#wt-announcement__container"
    );

    this.slides = Array.from(
      this.querySelectorAll(".wt-announcement__slide")
    );

    this.closeButton = this.querySelector(
      ".wt-announcement__close"
    );

    this.interval =
      Number(this.dataset.interval) || 5000;


    this.next = this.next.bind(this);

    this.previous = this.previous.bind(this);

    this.start = this.start.bind(this);

    this.stop = this.stop.bind(this);

    this.handleTouchStart =
      this.handleTouchStart.bind(this);

    this.handleTouchMove =
      this.handleTouchMove.bind(this);

    this.handleTouchEnd =
      this.handleTouchEnd.bind(this);

    this.hideForOneDay =
      this.hideForOneDay.bind(this);
  }


  connectedCallback() {

    if (
      !this.track ||
      this.slides.length === 0
    ) {
      return;
    }


    /*
     * Mostra sempre il primo messaggio
     * all'inizializzazione.
     */

    this.goTo(0, false);


    /*
     * Se abbiamo più di un messaggio
     * abilitiamo rotazione e swipe.
     */

    if (this.slides.length > 1) {

      this.start();


      /*
       * Desktop:
       * pausa quando il mouse è sopra
       * la barra.
       */

      this.addEventListener(
        "mouseenter",
        this.stop
      );

      this.addEventListener(
        "mouseleave",
        this.start
      );


      /*
       * Accessibility:
       * pausa quando un link riceve focus.
       */

      this.addEventListener(
        "focusin",
        this.stop
      );

      this.addEventListener(
        "focusout",
        this.start
      );


      /*
       * Mobile swipe.
       */

      this.track.addEventListener(
        "touchstart",
        this.handleTouchStart,
        {
          passive: true,
        }
      );

      this.track.addEventListener(
        "touchmove",
        this.handleTouchMove,
        {
          passive: true,
        }
      );

      this.track.addEventListener(
        "touchend",
        this.handleTouchEnd,
        {
          passive: true,
        }
      );

    }


    /*
     * Pulsante chiusura.
     */

    if (this.closeButton) {

      this.closeButton.addEventListener(
        "click",
        this.hideForOneDay
      );

    }

  }


  /*
   * ========================================================
   * GO TO SLIDE
   * ========================================================
   */

  goTo(index, animate = true) {

    if (
      !this.track ||
      this.slides.length === 0
    ) {
      return;
    }


    this.currentIndex =
      (
        index +
        this.slides.length
      ) %
      this.slides.length;


    this.track.style.transition =
      animate
        ? "transform .45s ease"
        : "none";


    this.track.style.transform =
      `translate3d(-${this.currentIndex * 100}%, 0, 0)`;


    /*
     * Accessibility.
     */

    this.slides.forEach(
      (slide, slideIndex) => {

        const active =
          slideIndex === this.currentIndex;


        slide.setAttribute(
          "aria-hidden",
          active ? "false" : "true"
        );


        slide
          .querySelectorAll(
            "a, button"
          )
          .forEach((element) => {

            element.tabIndex =
              active ? 0 : -1;

          });

      }
    );

  }


  /*
   * ========================================================
   * NEXT
   * ========================================================
   */

  next() {

    this.goTo(
      this.currentIndex + 1
    );

  }


  /*
   * ========================================================
   * PREVIOUS
   * ========================================================
   */

  previous() {

    this.goTo(
      this.currentIndex - 1
    );

  }


  /*
   * ========================================================
   * START AUTOPLAY
   * ========================================================
   */

  start() {

    if (this.slides.length <= 1) {
      return;
    }


    this.stop();


    this.intervalId =
      window.setInterval(
        this.next,
        this.interval
      );

  }


  /*
   * ========================================================
   * STOP AUTOPLAY
   * ========================================================
   */

  stop() {

    if (!this.intervalId) {
      return;
    }


    window.clearInterval(
      this.intervalId
    );


    this.intervalId = null;

  }


  /*
   * ========================================================
   * TOUCH
   * ========================================================
   */

  handleTouchStart(event) {

    this.stop();


    this.touchStartX =
      event.touches[0].clientX;


    this.touchEndX =
      this.touchStartX;

  }


  handleTouchMove(event) {

    this.touchEndX =
      event.touches[0].clientX;

  }


  handleTouchEnd() {

    const delta =
      this.touchEndX -
      this.touchStartX;


    if (Math.abs(delta) > 35) {

      if (delta < 0) {

        this.next();

      } else {

        this.previous();

      }

    }


    this.start();

  }


  /*
   * ========================================================
   * HIDE FOR 24 HOURS
   * ========================================================
   */

  hideForOneDay() {

    const oneDayLater =
      Date.now() +
      24 *
      60 *
      60 *
      1000;


    localStorage.setItem(
      "wt-announcement-hidden",
      oneDayLater
    );


    this.stop();


    this.style.display = "none";

  }


  /*
   * ========================================================
   * CLEANUP
   * ========================================================
   */

  disconnectedCallback() {

    this.stop();


    this.removeEventListener(
      "mouseenter",
      this.stop
    );

    this.removeEventListener(
      "mouseleave",
      this.start
    );

    this.removeEventListener(
      "focusin",
      this.stop
    );

    this.removeEventListener(
      "focusout",
      this.start
    );


    if (this.track) {

      this.track.removeEventListener(
        "touchstart",
        this.handleTouchStart
      );

      this.track.removeEventListener(
        "touchmove",
        this.handleTouchMove
      );

      this.track.removeEventListener(
        "touchend",
        this.handleTouchEnd
      );

    }


    if (this.closeButton) {

      this.closeButton.removeEventListener(
        "click",
        this.hideForOneDay
      );

    }

  }
}


if (
  !customElements.get(
    "announcement-bar"
  )
) {

  customElements.define(
    "announcement-bar",
    AnnouncementBar
  );

}